import { Switch } from '@welbe/design-system';
import { useState } from 'react';

type StatusSwitchProps = {
	id: string;
	status?: string;
	onToggle: (id: string, active: boolean) => Promise<void>;
};

export const StatusSwitch = ({ id, status, onToggle }: StatusSwitchProps) => {
	const [checked, setChecked] = useState<boolean>(status === 'active');
	const [isLoading, setLoading] = useState<boolean>(false);

	const handleChange = async (active: boolean) => {
		setChecked(active);
		setLoading(true);

		try {
			await onToggle(id, active);
		} catch {
			setChecked(!active);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Switch.Snippet
			checked={checked}
			disabled={isLoading}
			onCheckedChange={({ checked }: { checked: boolean }) =>
				handleChange(checked)
			}
		/>
	);
};
